import React from "react";
import Availability from "./Availability";
import Mobility from "./Mobility";
import Motivations from "./Motivations";
import RemoteWork from "./RemoteWork";
import SalarialCondition from "./SalarialCondition";
import TypeOfPermit from "./TypeOfPermit";
import { useInterviewContext } from "../InterviewContext";

const AvailabilityAndConditions = () => {
  const { interview, setInterview } = useInterviewContext();

  return (
    <>
      <Availability />
      <Motivations />
      <Mobility />
      <TypeOfPermit
        setTypeOfPermit={({ target }) =>
          setInterview({ ...interview, [target.name]: target.value })
        }
        typeOfPermit={interview.permit}
      />
      <RemoteWork />
      <SalarialCondition />
    </>
  );
};

export default AvailabilityAndConditions;
